module.exports = __webpack_public_path__ + "img/header_img.ff26df2a.png";